import { fetchApi } from '@/config/axiosSetting';
import {
  GetSignatureQueryParamsResponseType,
  GetSignatureQueryParamsType,
} from '@/modules/adjusterReportModules/queries/getSignature/getSignatureQuery.type';

export const getInitialVisitSignatureQueryFunction = (
  params: GetSignatureQueryParamsType,
): Promise<GetSignatureQueryParamsResponseType> => {
  return fetchApi.get(`/initial/reports/${params.id}/images/signature/`, {
    params: { damaged_id: params.damagedId },
  });
};
